import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const DefaultLayout = () => {
    const { loggedInUser } = useAuth();

    if (loggedInUser) {
        return <Navigate replace to={"/dashboard"} />;
    }

    return (
        <>
            <Outlet />
        </>
    );
};

export default DefaultLayout;
